import { StepKey } from "@/src/lib/workflows/steps/types";

const caseStepKeys = [
  StepKey.ENSURE_PATIENT,
  StepKey.CLINICIENT_ENSURE_CASE,
  StepKey.CLINICIENT_CONFIGURE_CASE,
  StepKey.CLINICIENT_CASE_DOCUMENT_UPLOAD,
  StepKey.CLINICIENT_DOCUMENT_NOTE,
  StepKey.CLINICIENT_SYNC_INSURANCE,
] as const;
const legacyStepKeys = [...caseStepKeys, StepKey.REFERRAL_SHEET_EXPORT] as const;

const authAndExportKeys = [
  StepKey.CLINICIENT_ENSURE_AUTHORIZATION,
  StepKey.CLINICIENT_AUTHORIZATION_DOCUMENT_UPLOAD,
  StepKey.CLINICIENT_AUTHORIZATION_TASK,
  StepKey.REFERRAL_SHEET_EXPORT,
] as const;

const referralStepKeysBeforeFax = [...caseStepKeys, ...authAndExportKeys] as const;

const caseStepKeysWithInheritance = [
  StepKey.ENSURE_PATIENT,
  StepKey.CLINICIENT_SAME_DAY_CASE_INHERITANCE,
  StepKey.CLINICIENT_ENSURE_CASE,
  StepKey.CLINICIENT_CONFIGURE_CASE,
  StepKey.CLINICIENT_CASE_DOCUMENT_UPLOAD,
  StepKey.CLINICIENT_DOCUMENT_NOTE,
  StepKey.CLINICIENT_SYNC_INSURANCE,
] as const;
const referralStepKeysWithInheritance = [...caseStepKeysWithInheritance, ...authAndExportKeys] as const;

export const CONFLUENT_REFERRAL_STEP_KEYS = [
  StepKey.REQUIRE_PATIENT_PHONE,
  ...referralStepKeysWithInheritance,
] as const;

const CONFLUENT_REFERRAL_STEP_KEYS_PRE_INHERITANCE = [
  StepKey.REQUIRE_PATIENT_PHONE,
  ...referralStepKeysBeforeFax,
] as const;

// Tasks persisted while the (since retired) same-day phone hold was the first step.
const CONFLUENT_REFERRAL_STEP_KEYS_PHONE_HOLD = [
  StepKey.CLINICIENT_SAME_DAY_PHONE_INHERITANCE,
  ...CONFLUENT_REFERRAL_STEP_KEYS,
] as const;

export type ConfluentReferralStepKey =
  | (typeof CONFLUENT_REFERRAL_STEP_KEYS)[number]
  | (typeof CONFLUENT_REFERRAL_STEP_KEYS_PHONE_HOLD)[number];

export function getConfluentReferralStepKeys(
  persistedStepKeys: readonly string[] = []
): readonly ConfluentReferralStepKey[] {
  // Return the sequence that matches an in-flight task's persisted step indices so they aren't reinterpreted.
  if (persistedStepKeys[0] === StepKey.ENSURE_PATIENT) {
    return persistedStepKeys[caseStepKeys.length] === StepKey.REFERRAL_SHEET_EXPORT
      ? legacyStepKeys
      : referralStepKeysBeforeFax;
  }

  if (persistedStepKeys[0] === StepKey.CLINICIENT_SAME_DAY_PHONE_INHERITANCE) {
    return CONFLUENT_REFERRAL_STEP_KEYS_PHONE_HOLD;
  }

  if (persistedStepKeys[2] === StepKey.CLINICIENT_ENSURE_CASE) {
    return CONFLUENT_REFERRAL_STEP_KEYS_PRE_INHERITANCE;
  }

  return CONFLUENT_REFERRAL_STEP_KEYS;
}
